import { toBool } from 'vopay';
import { usePermissions } from '../providers/Permissions.provider';
import { useClientLogin } from '../providers/ClientLogin.provider';

// True only when the account has the sub-accounts feature enabled (login
// `SubAccountPermissions`) and the current user can view sub-accounts. Gates the
// role drawers' "apply to sub-accounts" checkbox and the Role Details row.
export default function useSubAccountsEnabled(): boolean {
  const { permissions } = usePermissions();
  const { response } = useClientLogin();
  return toBool(response?.SubAccountPermissions) && !!permissions.ViewSubaccounts;
}
